export default __webpack_public_path__ + "static/css-b1dc9eeb13b9837cea03e95d234b08d4.png";